(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryDialogController', ProviderCountryDialogController);

    ProviderCountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProviderCountry'];

    function ProviderCountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProviderCountry) {
        var vm = this;

        vm.providerCountry = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.providerCountry.id !== null) {
                ProviderCountry.update(vm.providerCountry, onSaveSuccess, onSaveError);
            } else {
                ProviderCountry.save(vm.providerCountry, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerCountryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
